import {styled} from "@mui/material/styles";
import {Box, Grid} from "@mui/material";

export const StyledWrapper = styled(Box)({
  height: '100%',
  fontFamily: "AvenirNext-Regular",
});

export const StyledBody = styled(Grid)(({ step, totalStep }) => ({
  flex: 1,
  height: '100%',
  overflowY: 'auto',
  paddingBottom: 48,
  ...(step === totalStep && {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  }),
}));

export const StyledTimer = styled(Box)({
  fontFamily: "AvenirNext-DemiBold",
  fontSize: 16,
  color: '#6c62f5',
  lineHeight: '1.3em',
});

export const StyledNote = styled(Box)({
  textAlign: 'center',
  color: "#6c62f5",
  fontSize: '0.8rem',
  fontStyle: 'italic',
});
